import { useEffect, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import {
  Box,
  Grid2,
  Link,
  Stack,
  Typography,
  useTheme,
  LinearProgress,
} from "@mui/material";
import { RichTextEditor } from "../../../../../MainComponents/RichTextEditor/RichTextEditor";
import { EGInput } from "../../../../../MainComponents/Input/EGInput";
import { EGSwitch } from "../../../../../MainComponents/Switch/Switch";
import { InvestigationButton } from "../../components/InvestigationButton";
import { ModalContainer } from "../../components/ModalContainer";
import { MUITabs } from "../../components/InvestigationComponents";
import { questionSchema } from "../schemas";
import { useParams } from "react-router";

import { generateAiInterview } from "../../../../../../apis/apiAi";

// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (form) => {
  const { isManually, question } = form;
  const errors = {};
  if (isManually && question.trim() === "") {
    errors.question = true;
  }
  return [Object.entries(errors).length === 0 ? true : false, errors];
};

// Modal de carga de preguntas para entrevistas
export const AddQuestionsToInterview = ({
  show,
  onHide,
  selectedQuestionForEdit,
  setSelectedQuestionForEdit,
  idx,
  interview,
  interviews,
  setInterview,
  handleSaveInterviews,
  alias,
  interviewed,
  from,
  onReload,
}) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();
  const { id } = useParams();

  const [typeOfQuestions, setTypeOfQuestions] = useState("manual");
  const isManually = typeOfQuestions === "manual";
  const [uploadedFile, setUploadedFile] = useState({
    name: "Plantilla de preguntas.xlsx",
    size: "15 KB",
  });
  const [manualQuestion, setManualQuestion] = useState(
    _.cloneDeep(questionSchema)
  );

  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});

  // Resetear valores al cerrar el modal
  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setUploadedFile(null);
        setTriedToSave(false);
        setTypeOfQuestions("manual");
        setManualQuestion(_.cloneDeep(questionSchema));
        // Reset selected question for edit
        if (selectedQuestionForEdit) {
          setSelectedQuestionForEdit(null);
        }
      }, 200);
    }
  }, [show]);

  // Validar cada que se hace un cambio
  useEffect(() => {
    if (triedToSave) {
      const [_, errors] = validateForm({
        isManually,
        question: manualQuestion.question,
      });
      setErrors(errors);
    }
  }, [uploadedFile, manualQuestion]);

  useEffect(() => {
    if (selectedQuestionForEdit) {
      setManualQuestion({
        question: selectedQuestionForEdit.question || "",
        details: selectedQuestionForEdit.details || "",
        answer: selectedQuestionForEdit.answer || "",
        answerDetails: selectedQuestionForEdit.answerDetails || "",
      });
    }
  }, [selectedQuestionForEdit]);

  const handleEdit = () => {
    const newInterview = _.cloneDeep(interview);
    newInterview.interview[selectedQuestionForEdit.idx] = manualQuestion;
    setInterview(newInterview);
    onHide();
  };

  const handleSubmit = () => {
    const [isValid, errors] = validateForm({
      isManually,
      question: manualQuestion.question,
    });
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({
        variant: "error",
        message: t("resources.missing_required_inputs"),
      });
      return;
    }
    if (isManually) {
      const newInterviews = _.cloneDeep(interviews);
      newInterviews[idx].interview.push(manualQuestion);
      handleSaveInterviews(newInterviews);
    } else {
      // handleAddQuestions(uploadedFile);
    }
    onHide();
  };

  const returnIsValid = (error) => {
    if (!triedToSave) return null;
    if (error) return false;
    return true;
  };

  const tabs = [
    {
      label: t("Agregar pregunta"),
      value: "manual",
      component: (
        <ManualWay
          selectedQuestionForEdit={selectedQuestionForEdit}
          manualQuestion={manualQuestion}
          setManualQuestion={setManualQuestion}
          errors={errors}
          returnIsValid={returnIsValid}
        />
      ),
    },
    {
      label: t("Generar con IA"),
      value: "template",
      component: (
        <TemplateWay
          uploadedFile={uploadedFile}
          setUploadedFile={setUploadedFile}
          errors={errors}
          returnIsValid={returnIsValid}
          alias={alias}
          report_id={id}
          interviewed={interviewed}
          from={from}
          onHide={onHide}
          onReload={onReload}
        />
      ),
    },
  ];

  return (
    <ModalContainer show={show} onHide={onHide}>
      {/* Header */}
      <Typography
        fontWeight={700}
        fontSize={28}
        color={theme.palette.ethicsBlue.main}
      >
        {isManually ? t("Cargar pregunta") : t("Cargar preguntas")}
      </Typography>
      <Typography fontSize={16} color="oxfordBlue">
        {isManually
          ? t("Carga manualmente la pregunta y/o respuesta")
          : t(
              "Sube todas tus preguntas y/o preguntas y respuestas desde plantilla"
            )}
      </Typography>

      <hr />

      <MUITabs
        tabs={tabs}
        value={typeOfQuestions}
        onChange={setTypeOfQuestions}
        defaultTab="manual"
      />

      {/* Buttons */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent={isManually ? "flex-end" : "space-between"}
        mt={2}
      >
        {/* {!isManually && (
          <InvestigationButton
            label={t("DESCARGAR PLANTILLA")}
            variant="main"
            outlined
          // onClick={handleDownloadTemplate}
          />
        )} */}
        {/* {!isManually && (
            <Stack direction="row" spacing={2}>
              <InvestigationButton
                label={t("CANCELAR")}
                variant="main"
                outlined
                onClick={onHide}
              />
              <InvestigationButton
                label={t("GENERAR CON IA")}
                variant="main"
              />
            </Stack>
          )} */}
        {isManually && (
          <Stack direction="row" spacing={2}>
            <InvestigationButton
              label={t("CANCELAR")}
              variant="main"
              outlined
              onClick={onHide}
            />
            <InvestigationButton
              label={t("CONFIRMAR")}
              variant="main"
              onClick={selectedQuestionForEdit ? handleEdit : handleSubmit}
            />
          </Stack>
        )}
      </Stack>
    </ModalContainer>
  );
};

// Agregar preguntas manualmente
const ManualWay = ({
  selectedQuestionForEdit,
  manualQuestion,
  setManualQuestion,
  errors,
  returnIsValid,
}) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const [activeDetails, setActiveDetails] = useState(
    selectedQuestionForEdit?.details ? true : false
  );
  const [addAnswer, setAddAnswer] = useState(
    selectedQuestionForEdit?.answer ? true : false
  );
  const [activeAnswerDetails, setActiveAnswerDetails] = useState(
    selectedQuestionForEdit?.answerDetails ? true : false
  );

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setManualQuestion({
      ...manualQuestion,
      [name]: value,
    });
  };

  return (
    <>
      <EGInput
        label="Pregunta"
        value={manualQuestion.question}
        name="question"
        onChange={handleChange}
        required={true}
        isValid={returnIsValid(errors?.question) ?? null}
        showSuccessValidation
        showHelpText={false}
      />

      <Box
        display="flex"
        justifyContent={activeDetails ? "flex-start" : "flex-end"}
      >
        {activeDetails ? (
          <EGInput
            label="Detalles"
            value={manualQuestion.details}
            name="details"
            onChange={handleChange}
            type="textarea"
            multiline
            rows={5}
            sx={{ mt: 2 }}
          />
        ) : (
          <Link
            onClick={() => setActiveDetails(true)}
            underline="hover"
            textAlign="end"
            sx={{ mt: 0.6 }}
          >
            + Agregar detalles
          </Link>
        )}
      </Box>

      <Grid2 container spacing={2} mt={1.8}>
        <Grid2
          size={{ xs: 12, lg: 6 }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            fontSize={16}
            fontWeight={600}
            color={theme.palette.secondary.main}
          >
            {t("Agregar respuesta")}
          </Typography>
          <EGSwitch
            size="small"
            checked={addAnswer}
            onChange={(e) => setAddAnswer(e.target.checked)}
          />
        </Grid2>
      </Grid2>

      {addAnswer && (
        <>
          <Box mt={2}>
            <RichTextEditor
              label={t("Respuesta")}
              value={manualQuestion.answer}
              onChange={(value) =>
                setManualQuestion({ ...manualQuestion, answer: value })
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent={activeAnswerDetails ? "flex-start" : "flex-end"}
          >
            {activeAnswerDetails ? (
              <EGInput
                label="Detalles de la respuesta"
                value={manualQuestion.answerDetails}
                name="answerDetails"
                onChange={handleChange}
                type="textarea"
                multiline
                rows={5}
                sx={{ mt: 2 }}
              />
            ) : (
              <Link
                onClick={() => setActiveAnswerDetails(true)}
                underline="hover"
                textAlign="end"
                sx={{ mt: 0.6 }}
              >
                + Agregar detalles de la respuesta
              </Link>
            )}
          </Box>
        </>
      )}
    </>
  );
};

const AIProgressMessages = ({ isGenerating, onComplete }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  const messages = [
    "Ordenando información...",
    "Informando al investigador virtual...",
    "Analizando datos del reporte...",
    "Generando estructura del plan...",
    "Creando archivo de investigación...",
    "Optimizando recomendaciones...",
    "Validando coherencia del contenido...",
    "Aplicando mejores prácticas...",
    "Personalizando actividades...",
    "Finalizando plan de actividades...",
    "Preparando resultado final...",
  ];

  useEffect(() => {
    if (!isGenerating) {
      setCurrentMessageIndex(0);
      setProgress(0);
      return;
    }

    // Cambiar mensaje cada 8 segundos
    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prev) => {
        if (prev < messages.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    }, 8000);

    // Actualizar progreso cada 500ms
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return 95; // No llegar al 100% hasta que termine
        return prev + Math.random() * 3 + 1;
      });
    }, 500);

    return () => {
      clearInterval(messageInterval);
      clearInterval(progressInterval);
    };
  }, [isGenerating]);

  // Completar al 100% cuando termine
  useEffect(() => {
    if (!isGenerating && progress > 0) {
      setProgress(100);
      setTimeout(() => {
        onComplete && onComplete();
      }, 500);
    }
  }, [isGenerating, progress, onComplete]);

  if (!isGenerating) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fa",
        border: "1px solid #e9ecef",
        borderRadius: 2,
        padding: 3,
        marginBottom: 2,
        textAlign: "center",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#1976d2",
          marginBottom: 2,
          fontWeight: 500,
        }}
      >
        🤖 Generando plan de actividades con IA
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "#666",
          marginBottom: 3,
          minHeight: 24,
          fontWeight: 500,
        }}
      >
        {messages[currentMessageIndex]}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: "#e3f2fd",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#1976d2",
            borderRadius: 4,
          },
        }}
      />

      <Typography
        variant="caption"
        sx={{
          color: "#888",
          marginTop: 1,
          display: "block",
        }}
      >
        {Math.round(progress)}% completado
      </Typography>
    </Box>
  );
};

// Agregar preguntas desde plantilla
const TemplateWay = ({
  uploadedFile,
  setUploadedFile,
  alias,
  report_id,
  interviewed,
  from,
  onHide,
  onReload,
}) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  // For IA Generator
  const [iaGenerator, setIaGenerator] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = async () => {
    setIsGenerating(true);

    const fullName = interviewed;
    const [name, role] = fullName.split("-");

    try {
      const interviewrep = await generateAiInterview({
        report_id: report_id,
        investigation_alias: alias,
        name: name,
        position: role,
        type: from,
      });
      onReload();
      onHide();
    } catch (error) {
      console.error("Error generando contenido:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeaa7",
          borderRadius: 1,
          padding: 2,
          marginBottom: 2,
        }}
      >
        <Typography variant="body2" sx={{ color: "#856404" }}>
          <strong>⚠️ Importante:</strong> La IA ha sido entrenada por expertos
          en investigaciones corporativas, pero la entrevista generada puede no
          ser aplicables a todas las organizaciones y personas por políticias
          internas.
          <strong>Revise y valide la viabilidad</strong> de cada una según el
          contexto específico de su empresa antes de proceder.
        </Typography>
      </Box>

      <AIProgressMessages
        isGenerating={isGenerating}
        onComplete={() => {
          // Aquí puedes agregar lógica adicional cuando termine
          console.log("Generación completada");
        }}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="flex-end"
        spacing={1}
        mt={2}
      >
        <InvestigationButton
          label={`${t("causes.gen")}`}
          variant="success"
          size="medium"
          icon="outline_ai"
          onClick={handleGenerate}
          disabled={isGenerating}
        />
      </Stack>
    </>
  );
};
